import {SET_EMAIL_VERIFICATION} from '../actions/types';

const emailVerification = (state = null, action) => {
  switch (action.type) {
    case SET_EMAIL_VERIFICATION:
      return action.payload;
    default:
      return state;
  }
};

export default emailVerification;